module.exports = __webpack_public_path__ + "img/slide-3.38dd8650.jpeg";